import apiFetch from '../apiFetch'

export default function ({dosisReales, volumenTipoDosis, codVerraco, nombreRaza, fechaExtraccion, volumenDiluyente, idAnalisisExtraccion, caducidad}) {
  return apiFetch({
    endPoint: `Analisis/imprimirEtiquetaPDF?dosisReales=${dosisReales}&volumenTipoDosis=${volumenTipoDosis}&codVerraco=${codVerraco}&nombreRaza=${nombreRaza}&fechaExtraccion=${fechaExtraccion}&volumenDiluyente=${volumenDiluyente}&idAnalisis=${idAnalisisExtraccion}&caducidad=${caducidad}`,
    method: 'GET', body: null, token: null
  })
}